/* Avis clients — deux comportements distincts.

   1. Le bouton « Rédiger un avis ». Le formulaire appartient à l'application
      d'avis : plutôt que d'en écrire un second, on relaie le clic vers le lien
      qu'elle pose dans son widget. Le widget arrivant après le rendu de la
      page, on le cherche au moment du clic et non au chargement.

   2. Le tri et la pagination de l'aperçu. Avec les vrais avis, c'est
      l'application qui s'en charge — son propre code écoute son propre
      balisage. L'aperçu, lui, est rendu par le thème : il lui faut donc son
      tri et son « voir tous les avis » à lui, sans quoi les deux commandes
      resteraient décoratives. Le code ci-dessous ne s'attache qu'au conteneur
      d'aperçu, jamais au widget de l'application.
*/

(function siritoReviews() {
  /* ---------------------------------------------------------------------
     Bouton de dépôt
     --------------------------------------------------------------------- */

  /* Notre bouton porte lui-même la classe « jdgm-write-rev-link » : quand
     l'application est en place, elle intercepte le clic avant nous et ouvre son
     formulaire — le code ci-dessous ne s'exécute alors pour rien.

     Le « :not » est indispensable : sans lui, le bouton se retrouverait dans sa
     propre liste de cibles et se cliquerait à l'infini. */
  const SELECTEURS = [
    // Widget de nouvelle génération : le bouton est masqué par notre feuille
    // de style, mais il répond toujours au clic — c'est lui qui ouvre la
    // fenêtre de dépôt de l'application.
    '.jm-action-buttons__button',
    '.jm-review-widget-minimal-header__action-buttons button',
    // Ancien widget.
    '.jdgm-form-wrapper .jdgm-write-rev-link',
    '.jdgm-widget .jdgm-write-rev-link:not([data-sirito-write-review])',
    '.jdgm-write-rev-link:not([data-sirito-write-review])',
    '[data-write-review]:not([data-sirito-write-review])',
  ];

  const MOT_APERCU =
    "Le formulaire d'avis est fourni par l'application Judge.me, " +
    "qui n'est pas encore active sur ce thème. Dans l'admin : Boutique en ligne " +
    '→ Thèmes → Personnaliser → Intégrations d\'applications → activez Judge.me. ' +
    'Ce message ne paraît que pendant l\'aperçu.';

  document.addEventListener('click', (event) => {
    const bouton = event.target.closest('[data-sirito-write-review]');
    if (!bouton) return;

    event.preventDefault();

    for (const selecteur of SELECTEURS) {
      const lien = document.querySelector(selecteur);
      if (lien) {
        lien.click();
        return;
      }
    }

    // Le formulaire de l'application peut aussi n'être qu'un bloc replié dans
    // son widget : on l'ouvre à la main plutôt que de ne rien faire.
    const formulaire = document.querySelector('.jdgm-form-wrapper, .jdgm-form');
    if (formulaire) {
      formulaire.classList.remove('jdgm-hidden');
      formulaire.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const champ = formulaire.querySelector('input, textarea, select');
      if (champ) champ.focus({ preventScroll: true });
      return;
    }

    // Plus rien à ouvrir. En aperçu, on le dit à la personne qui règle la
    // boutique ; en production, on la mène au moins jusqu'aux avis.
    const note = document.querySelector('[data-sirito-write-note]');
    if (bouton.hasAttribute('data-sirito-demo-write') && note) {
      note.textContent = MOT_APERCU;
      note.hidden = false;
      return;
    }

    const widget = document.querySelector('.sirito-reviews__widget');
    if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------------------------------------------------------------------
     Tri et pagination de l'aperçu
     --------------------------------------------------------------------- */

  // Nombre d'avis affichés avant d'avoir cliqué sur « Voir tous les avis ».
  const PAR_PAGE = 5;

  const nombre = (element, cle) => Number(element.dataset[cle] || 0);

  const animer = (widget) => {
    const liste = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!liste) return;

    const tous = Array.from(liste.querySelectorAll('.jdgm-rev'));
    if (!tous.length) return;

    const tri = widget.querySelector('[data-sirito-demo-sort]');
    const pagination = widget.querySelector('[data-sirito-demo-paginate]');
    const bouton = widget.querySelector('[data-sirito-demo-more]');
    const vide = widget.querySelector('[data-sirito-demo-empty]');

    // L'ordre initial du balisage sert de référence pour « Plus récents » :
    // les avis y sont déjà du plus frais au plus ancien.
    const ordreInitial = tous.slice();
    let tout_afficher = false;

    const comparateurs = {
      recent: (a, b) => nombre(a, 'age') - nombre(b, 'age'),
      best: (a, b) => nombre(b, 'score') - nombre(a, 'score') || nombre(a, 'age') - nombre(b, 'age'),
      worst: (a, b) => nombre(a, 'score') - nombre(b, 'score') || nombre(a, 'age') - nombre(b, 'age'),
      pictures: (a, b) => nombre(a, 'age') - nombre(b, 'age'),
    };

    const peindre = () => {
      const mode = tri && comparateurs[tri.value] ? tri.value : 'recent';

      // « Avec photo » est un filtre, pas un tri : il réduit la liste au lieu
      // de la réordonner. Les autres modes gardent les dix avis.
      const retenus =
        mode === 'pictures'
          ? ordreInitial.filter((avis) => avis.dataset.pictures === 'true')
          : ordreInitial.slice();

      retenus.sort(comparateurs[mode]);

      // On repose les avis dans l'ordre voulu, puis les écartés à la suite :
      // ils restent dans le document — masqués — pour que le filtre soit
      // réversible sans re-rendre quoi que ce soit.
      retenus.forEach((avis) => liste.appendChild(avis));
      ordreInitial.forEach((avis) => {
        if (!retenus.includes(avis)) liste.appendChild(avis);
      });

      const limite = tout_afficher ? retenus.length : PAR_PAGE;
      ordreInitial.forEach((avis) => {
        avis.hidden = true;
      });
      retenus.slice(0, limite).forEach((avis) => {
        avis.hidden = false;
      });

      if (vide) vide.hidden = retenus.length > 0;
      if (pagination) pagination.hidden = retenus.length <= limite;
    };

    if (tri) {
      tri.addEventListener('change', () => {
        // Changer de tri rouvre la liste courte : on repart du haut, comme
        // le fait l'application.
        tout_afficher = false;
        peindre();
      });
    }

    if (bouton) {
      bouton.addEventListener('click', () => {
        tout_afficher = true;
        peindre();
      });
    }

    peindre();
  };

  const demarrer = () => {
    document.querySelectorAll('[data-sirito-demo-reviews]').forEach(animer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // Le personnalisateur remplace la section sans recharger la page.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-sirito-demo-reviews]').forEach(animer);
  });
})();
